import React, { Component } from 'react';

class ErrorRow extends Component {
  render() {

    if(!this.props.orders) {
      return null
    } 

    return (
      
        this.props.orders.map((order, index) => (
          !order.valid && order.errorMsg && order.errorMsg.length > 0 && (
            <tr className='error-message' key={index}>
                <td colSpan="100%"><p className="error-message__text">{order.errorMsg}</p></td>
            </tr>
          )
        ))
    )
  }
}

export default ErrorRow


// WEBPACK FOOTER //
// ./src/components/Orders/ErrorRow.js